import { IBackend, IBoot, IFirebaseSettings } from '../types';
import { bootUrl } from './config';

class BootConfig {
  configuration: IBoot;

  async init(): Promise<IBoot> {
    const a = await fetch(bootUrl);
    const b: IBoot = await a.json();
    return Promise.resolve(b);
  }

  async backendBaseUrl(backendId: string): Promise<string> {
    if (!this.configuration) {
      this.configuration = await this.init();
    }
    const backend: IBackend = this.configuration.backends[backendId];
    return backend.baseUrl;
  }

  async getAuth(): Promise<any> {
    if (!this.configuration) {
      this.configuration = await this.init();
    }
    return this.configuration.auth;
  }

  async getFirebase(): Promise<IFirebaseSettings> {
    if (!this.configuration) {
      this.configuration = await this.init();
    }
    return this.configuration.firebase;
  }

  i18nLoadPath(): string {
    return `/locales/{{lng}}/{{ns}}.json`;
  }
}

export const config = new BootConfig();
